export default {"src":"/_next/static/media/logo.ab7b40cf.svg","height":449,"width":1600,"blurWidth":0,"blurHeight":0};